import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useResetThemeMutation = createMutationHook(ShopRendererThemesApiClient.reset, {
  mutationKey: ['resetTheme'],
})
